import {
  LOAD_PSL,
  LOAD_PSL_ERROR,
  TOGGLE_REMOVE_FROM_PSL_MODAL,
  SET_REMOVE_FROM_PSL_LOADING,
  SUBMIT_REMOVE_FROM_PSL,
  SUBMIT_REMOVE_FROM_PSL_ERROR,
  CANCEL_REMOVE_FROM_PSL,
  SHOW_FLASH_MESSAGE,
  HIDE_FLASH_MESSAGE,
} from "../actions/types";

const initialState = {
  loading: true,
  isEmployer: false,
  isPortalUser: false,
  removeFromPslLoading: false,
  removeModalActive: false,
  suppliersList: [],
  showFlashMessage: false,
  errors: {},
};

export default function preferredSuppliersListReducer(
  state = initialState,
  action
) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_PSL:
      return {
        ...state,
        loading: false,
        isEmployer: payload.isEmployer,
        isPortalUser: payload.isPortalUser,
        suppliersList: payload.suppliersList,
        errors: {},
      };
    case LOAD_PSL_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
        suppliersList: [],
      };
    case TOGGLE_REMOVE_FROM_PSL_MODAL:
      return {
        ...state,
        removeModalActive: !state.removeModalActive,
      };
    case SET_REMOVE_FROM_PSL_LOADING:
      return {
        ...state,
        removeFromPslLoading: true,
      };
    case SUBMIT_REMOVE_FROM_PSL:
      return {
        ...state,
        loading: false,
        suppliersList: state.suppliersList.filter(
          (supplier) => supplier.id !== payload
        ),
        removeFromPslLoading: false,
        removeModalActive: false,
        errors: {},
      };
    case SUBMIT_REMOVE_FROM_PSL_ERROR:
      return {
        ...state,
        loading: false,
        removeFromPslLoading: false,
        errors: payload,
      };
    case CANCEL_REMOVE_FROM_PSL:
      return {
        ...state,
        loading: false,
        errors: {},
      };
    case SHOW_FLASH_MESSAGE:
      return {
        ...state,
        showFlashMessage: true,
      };
    case HIDE_FLASH_MESSAGE:
      return {
        ...state,
        showFlashMessage: false,
      };
    default:
      return state;
  }
}
